import TextAreaInput from '../Inputs/TextareaInput';
import wrapWithField from '../../HOC/wrapWithField';
var TextField = wrapWithField(TextAreaInput);
export default TextField;